import React from 'react'
import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { resetUser, updateUserState } from 'features/Authentication/user.slice'
import { useDispatch, useSelector } from 'react-redux'
import { useDeviceType } from 'app/hooks/useDeviceType'
import { userState } from 'Constants/userRegistrationStatus'
import { useLogoutUserMutation } from 'Services/API/posp.api'
import { ToastService } from 'Services/toast.service'
import { AiOutlineMenu } from 'react-icons/ai'
import { PospImages } from 'Assets/Posp'

export const PospHeader = () => {
  const { isMobile } = useDeviceType()
  const { isLoggedIn, authenticatedUser } = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  const [logoutUser] = useLogoutUserMutation({})

  const handleLogout = async () => {
    try {
      const logoutUserResp = await logoutUser({
        idle: false,
      })
      console.log(logoutUserResp)
      navigate('/')
      localStorage.clear()
      sessionStorage.clear()
      dispatch(resetUser())
      dispatch(updateUserState(userState))
    } catch (e) {
      console.log(e)
    }
  }
  // console.log(authenticatedUser);
  return (
    <>
      <Box
        shadow='DEFAULT'
        // backgroundColor={'rgb(244, 246, 250)'}
        h='70px'
        paddingTop='4'
        w='full'
        zIndex={41}
      >
        <Flex paddingX='8' justifyContent='space-between'>
          <Flex alignItems='center' gridColumn='2' padding='1' w='120px' h='45px'>
            <Text
              onClick={() => {
                navigate(isLoggedIn ? '/registration-status' : '/')
              }}
            >
              {/* <img
                src='https://foundation-dev.theblackswan.in/media/NinQfhwKoGUVBaPouz41JQ=='
                alt='logo'
              /> */}
              <Image src={PospImages.ZopperLogo} />
            </Text>
          </Flex>
          <Flex gap={9} alignItems='center'>
            {/* <Menu>
              <MenuButton as={Button} colorScheme='primary' variant='link'>
                Need Help ?
              </MenuButton>
              <MenuList fontSize='sm'>
                <MenuGroup>
                  <Text color='#153467' pl='4' py='2'>
                    <BsFillTelephoneFill style={{ display: 'inline-block', marginRight: '10px' }} />
                    +91 9899588234
                  </Text>
                  <Text color='#153467' pl='4' py='2'>
                    <MdMail style={{ display: 'inline-block', marginRight: '10px' }} />
                    prime.support@zopper.com
                  </Text>
                </MenuGroup>
              </MenuList>
            </Menu> */}
            {!isMobile ? (
              <>
                {isLoggedIn && (
                  <Button
                    onClick={() => {
                      navigate('/registration-status')
                    }}
                    colorScheme='primary'
                    variant='link'
                    isDisabled={location.pathname === '/registration-status'}
                  >
                    Home
                  </Button>
                )}

                {isLoggedIn ? (
                  <Menu>
                    <MenuButton
                      as={Button}
                      colorScheme='primary'
                      variant='link'
                      rightIcon={<ChevronDownIcon />}
                    >
                      {authenticatedUser?.first_name}
                    </MenuButton>
                    <MenuList fontSize='sm'>
                      <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
                    </MenuList>
                  </Menu>
                ) : (
                  <Button
                    onClick={() => {
                      navigate('/')
                    }}
                    colorScheme='primary'
                    variant='link'
                  >
                    Login
                  </Button>
                )}
              </>
            ) : (
              <Menu placement='left'>
                <MenuButton
                  as={Button}
                  colorScheme='primary'
                  variant='link'
                  rightIcon={<AiOutlineMenu size='30px' />}
                />
                <MenuList bg='white' fontSize='sm'>
                  <MenuItem
                    isDisabled={location.pathname === '/registration-status'}
                    onClick={() => navigate('/registration-status')}
                  >
                    Home
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
                </MenuList>
              </Menu>
            )}
          </Flex>
        </Flex>
      </Box>
    </>
  )
}
